import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarUbicacionConfiguracion } from '../../../actions/configuracion';

const EliminarUbicacion = ({ ubicacion, reestablecerUbicacion }) => {

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (ubicacion && ubicacion._id) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [ubicacion]);

    const handleClose = () => {
        setShow(false);
        reestablecerUbicacion(null);
    };

    const handleEliminar = async () => {
        if (!ubicacion || !ubicacion._id) return;

        const resp = await dispatch(
            eliminarUbicacionConfiguracion(ubicacion._id)
        );

        if (resp && resp.success) {
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <div className="modal-header">
                <h5 className="modal-title">Eliminar ubicación</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                ></button>
            </div>

            <div className="modal-body">
                <p>
                    ¿Deseas eliminar la ubicación <strong>{ubicacion?.nombre}</strong>?
                </p>

                <div className="d-flex justify-content-center">
                    <button
                        type="button"
                        className="btn btn-danger me-2"
                        onClick={handleClose}
                    >
                        ✖ No
                    </button>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleEliminar}
                    >
                        ✔ Sí, eliminar
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default EliminarUbicacion;
